import React from "react";

const EmailNotification = () => {
  return (
    <div className="p-6">
      <h2 className="text-white text-lg font-medium mb-4">
        Email Notifications
      </h2>
      <div className="flex flex-col items-start">
        <label htmlFor="notification-1" className="flex items-center mb-4">
          <input
            type="checkbox"
            name="notification-1"
            id="notification-1"
            className="mr-2"
          />
          New booking confirmations
        </label>
        <label htmlFor="notification-2" className="flex items-center mb-4">
          <input
            type="checkbox"
            name="notification-2"
            id="notification-2"
            className="mr-2"
          />
          Special offers and promotions
        </label>
        <label htmlFor="notification-3" className="flex items-center mb-4">
          <input
            type="checkbox"
            name="notification-3"
            id="notification-3"
            className="mr-2"
          />
          Feedback requests
        </label>
        <p className="text-sm text-gray-400 mb-4">
          Decide what you want to be notified about, and unsubscribe from what
          you don't.
        </p>
        <button className="bg-black hover:scale-[1.05] transition-all text-white px-4 py-2 rounded">
          Manage Email Preferences
        </button>
        <p className="text-sm text-gray-400 mt-4">
          This is the email address you use to sign in. It’s also where we send
          your booking confirmations.
        </p>
        <p className="text-white font-bold mt-2">
          rishabhsagarajmer@gmail.com
        </p>
      </div>
    </div>
  );
};

export default EmailNotification;
